<p>
  <span data-test-departure-date> {{ flightOrBound.departure.dateTime | finDateFormat: 'DATE' }} </span> /
  <span data-test-departure>
    {{ flightOrBound.departure.dateTime | finTime }} {{ flightOrBound.departure.locationCode }}
  </span>
  <span data-test-icon>
    <fcom-icon name="aircraft-horizontal" class="icon-small"></fcom-icon>
  </span>
  <span data-test-arrival-date>
    {{ flightOrBound.arrival.dateTime | finTime }}
  </span>
  <span
    data-test-plus-one
    *ngIf="returnIsDifferentDay"
    class="flex--self-start font-body-2 nordic-blue-900-text valign-top"
  >
    +1
  </span>
  <span data-test-arrival-location-code>
    {{ flightOrBound.arrival.locationCode }}
  </span>
  /
  <span data-test-airline-name *ngFor="let uniqueAirlineName of uniqueAirlineNames; let last = last">
    {{ uniqueAirlineName }}<ng-container *ngIf="!last">,</ng-container>
  </span>
  / <span data-test-duration> {{ flightOrBound?.duration | finDuration | async }} </span> /
  <span data-test-stops [ngSwitch]="stops">
    <ng-container class="" *ngSwitchCase="0">{{ 'bookingSummary.direct' | finLocalization }}</ng-container>
    <ng-container *ngSwitchCase="1">{{ 'stopOver' | finLocalization: [stops] }}</ng-container>
    <ng-container *ngSwitchDefault>{{ 'stopOvers' | finLocalization: [stops] }}</ng-container>
  </span>
  <span *ngIf="fareFamily || cabinClass">
    /
    <span data-test-brand-name> {{ fareFamily ?? (cabinClass | finLocalization) }} </span>
  </span>
</p>
